import { useUser } from "@auth0/nextjs-auth0";
import { userOrgRole, userRolesAtom } from "atoms/user";
import { useEffect, useState } from "react";
import { useRecoilValueLoadable } from "recoil";

export const useRole = () => {
  const { user } = useUser();
  // const [role, setRole] = useState(null);

  const role = useRecoilValueLoadable(userRolesAtom);
  const orgRole = useRecoilValueLoadable(userOrgRole);

  // useEffect(() => {
  //   if (typeof user !== "undefined" && role === null) {
  //     setRole(user?.["https://api.bodycam.report/roles"]);
  //   }
  // }, [user]);

  const returnArray = [];

  role.state === "hasValue"
    ? returnArray.push(role.contents)
    : returnArray.push("");
  orgRole.state === "hasValue"
    ? returnArray.push(orgRole.contents)
    : returnArray.push("");

  if (returnArray.length > 0) {
    return returnArray;
  }

  return null;
};
